import { navigationSidebarAutomationLegacyEnabledResource } from '@atlassian/jira-router-resources-navigation-sidebar-automation/src/index.tsx';
import { useResource } from '@atlassian/react-resource-router';
import type { UseServiceDeskAutomationLegacyEnabledResource } from './types.tsx';

export const useNavigationAutomationLegacyEnabledResource =
	(): UseServiceDeskAutomationLegacyEnabledResource => {
		const { data, loading } = useResource(navigationSidebarAutomationLegacyEnabledResource);
		return { data, loading };
	};
